import React, { useEffect, useMemo, useRef, useState } from 'react';
import './App.css';
import './LandingPage.css';
import Carousel from './Carousel';
import slide1 from './assets/slide1.png';
import slide3 from './assets/slide3.png';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from './languageContext';
import LanguageToggle from './LanguageToggle';
import { FullPageLoader, useRouteEntryLoader } from './navigationLoader';

// const IDLE_CAROUSEL_DELAY = 3 * 60 * 1000;
const IDLE_CAROUSEL_DELAY = 10 * 1000;

const TRANSLATIONS = {
  en: {
    headingLine1: 'Instant Loans',
    headingLine2: 'for Salaried Professionals',
    subtitle: 'Zero Paperwork. 100% Digital.',
    applyNow: 'APPLY NOW',
    luckyDraw: 'Lucky Draw',
    spinTitle: 'Spin & Win!',
    spinSub: 'Win cashback, fee cuts, and surprise perks in one quick spin.',
    spinning: 'Spinning...',
    rewardLocked: 'Reward Locked In',
    spinNow: 'Spin Now',
    youWon: 'You won:',
    modalTitle: 'You Won!',
    modalDescLine1: 'Your reward is applied automatically.',
    modalDescLine2: 'Apply for a loan to redeem it!',
    modalApply: 'Apply Now ->',
    close: 'Close',
    slides: [
      { image: process.env.PUBLIC_URL + '/nbfc1.png' },
      { image: slide3, text: 'No CIBIL Required \n Apply now' },
      { image: process.env.PUBLIC_URL + '/image3_corporate_final.png', text: 'Zero Paperwork for Salaried Employees \n Apply now' },
      { image: process.env.PUBLIC_URL + '/Rahul_Sir1.png', text: 'Simple Process. Quick Disbursal. Trusted by Professionals \n Apply now' },
      { image: process.env.PUBLIC_URL + '/depressed1.png', text: 'Expenses More Than Salary? Get a Top-up instantly! \n Apply now' },
      { image: slide1, text: 'Upgrade Your Lifestyle Today \n Apply now' },
      { image: process.env.PUBLIC_URL + '/travling.jpg', text: 'Salary khatam ho gayi,Pahado pe jana hai \n Apply now' },
      { image: process.env.PUBLIC_URL + '/indian_parents.png', text: 'Salary khatam ho gayi! \n Mummy papa ko anniversary gift Dena hai? \n Apply now' },
      { image: process.env.PUBLIC_URL + '/Dating+blog1.webp', text: 'Salary khatam ho gayi! \n Date pe jana hai \n Apply now' },
      { image: process.env.PUBLIC_URL + '/birthday3.png', text: 'Apke bacche ka birthday hai \n Salary khatam ho gayi \n Apply now' },
      { image: process.env.PUBLIC_URL + '/school.jpg', text: 'Bacche ki school fees bharni hai? \n Salary khatam ho gayi \n Apply now' },
      { image: process.env.PUBLIC_URL + '/hospital1.png', text: 'Medical Emergency? \n We are here to help \n Apply now' },
      { image: process.env.PUBLIC_URL + '/loan_rejection1.png', text: "Loan Rejection se Pareshan Don't worry meri jaan? \n Apply now" },
      { image: process.env.PUBLIC_URL + '/Insurance_Due.png', text: 'Insurance Premium due Pareshan Kyu? \n Apply now' }
    ],
    segmentLabels: {
      fee5: '5%\nProcessing\nFee',
      fee10: '10%\nProcessing\nFee',
      fee15: '15%\nProcessing\nFee',
      fee20: '20%\nProcessing\nFee'
    }
  },
  hi: {
    headingLine1: 'सैलरीड प्रोफेशनल्स के लिए',
    headingLine2: 'इंस्टेंट लोन',
    subtitle: 'जीरो पेपरवर्क। 100% डिजिटल।',
    applyNow: 'अभी अप्लाई करें',
    luckyDraw: 'लकी ड्रॉ',
    spinTitle: 'स्पिन करो और जीतों!',
    spinSub: 'एक स्पिन में कैशबैक, प्रोसेसिंग फी छूट और सरप्राइज फायदे पाएं।',
    spinning: 'स्पिन हो रहा है...',
    rewardLocked: 'रिवॉर्ड लॉक हो गया',
    spinNow: 'अभी स्पिन करें',
    youWon: 'आपने जीता:',
    modalTitle: 'बधाई हो!',
    modalDescLine1: 'आपका रिवॉर्ड अपने आप लागू हो गया है।',
    modalDescLine2: 'इसे पाने के लिए लोन अप्लाई करें!',
    modalApply: 'अभी अप्लाई करें ->',
    close: 'बंद करें',
    slides: [
      { image: process.env.PUBLIC_URL + '/nbfc.jpeg' },
      { image: slide3, text: 'CIBIL की जरूरत नहीं \n अभी अप्लाई करें' },
      { image: process.env.PUBLIC_URL + '/image3_corporate_final.png', text: 'सैलरीड कर्मचारियों के लिए जीरो पेपरवर्क \n अभी अप्लाई करें' },
      { image: process.env.PUBLIC_URL + '/Rahul_Sir1.png', text: 'आसान प्रक्रिया। तेज डिस्बर्सल। प्रोफेशनल्स का भरोसा। \n अभी अप्लाई करें' },
      { image: process.env.PUBLIC_URL + '/Depresd.png', text: 'खर्च सैलरी से ज्यादा? तुरंत टॉप-अप लें! \n अभी अप्लाई करें' },
      { image: slide1, text: 'आज ही अपनी लाइफस्टाइल अपग्रेड करें \n अभी अप्लाई करें' },
      { image: process.env.PUBLIC_URL + '/travling.jpg', text: 'सैलरी खत्म हो गई, पहाड़ों पर जाना है \n अभी अप्लाई करें' },
      { image: process.env.PUBLIC_URL + '/indian_parents.png', text: 'सैलरी खत्म हो गई! \n मम्मी-पापा को एनिवर्सरी गिफ्ट देना है? \n अभी अप्लाई करें' },
      { image: process.env.PUBLIC_URL + '/Dating+blog1.webp', text: 'सैलरी खत्म हो गई! \n डेट पर जाना है \n अभी अप्लाई करें' },
      { image: process.env.PUBLIC_URL + '/Birthday2.png', text: 'आपके बच्चे का जन्मदिन है \n सैलरी खत्म हो गई \n अभी अप्लाई करें' },
      { image: process.env.PUBLIC_URL + '/school.jpg', text: 'बच्चे की स्कूल फीस भरनी है? \n सैलरी खत्म हो गई \n अभी अप्लाई करें' },
      { image: process.env.PUBLIC_URL + '/hospital.jpg', text: 'मेडिकल इमरजेंसी? \n हम आपकी मदद के लिए हैं \n अभी अप्लाई करें' },
      { image: process.env.PUBLIC_URL + '/loan_rejection.png', text: 'लोन रिजेक्शन से परेशान? चिंता मत करो मेरी जान \n अभी अप्लाई करें' },
      { image: process.env.PUBLIC_URL + '/Insurance_Due.png', text: 'इंश्योरेंस प्रीमियम ड्यू है? परेशान क्यों? \n अभी अप्लाई करें' }
    ],
    segmentLabels: {
      fee5: '5%\nप्रोसेसिंग\nफीस',
      fee10: '10%\nप्रोसेसिंग\nफीस',
      fee15: '15%\nप्रोसेसिंग\nफीस',
      fee20: '20%\nप्रोसेसिंग\nफीस'
    }
  }
};

const SEGMENT_META = [
  { key: 'fee5', percent: 5, color: '#ef4444', textColor: '#fff', emoji: '🎁' },
  { key: 'fee10', percent: 10, color: '#3b82f6', textColor: '#fff', emoji: '🎁' },
  { key: 'fee15', percent: 15, color: '#10b981', textColor: '#fff', emoji: '🎁' },
  { key: 'fee20', percent: 20, color: '#f59e0b', textColor: '#fff', emoji: '🎁' }
];

function LandingPage() {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const t = TRANSLATIONS[language] || TRANSLATIONS.en;
  const entryLoaderMessage = useRouteEntryLoader('Opening start page...');

  const slides = useMemo(() => t.slides, [t]);
  const segments = useMemo(
    () =>
      SEGMENT_META.map((segment) => ({
        ...segment,
        label: t.segmentLabels[segment.key]
      })),
    [t]
  );

  const getLandingWheelSize = () => {
    const isPortrait = window.innerHeight > window.innerWidth;
    if (isPortrait) {
      return Math.max(700, Math.min(900, Math.floor(window.innerWidth * 0.95)));
    }

    return 700;
  };

  // Spin state
  const canvasRef = useRef(null);
  const spinRef = useRef({ rotation: 0, rafId: null });
  const idleTimerRef = useRef(null);
  const [isSpinning, setIsSpinning] = useState(false);
  const [hasSpun, setHasSpun] = useState(false);
  const [spinResult, setSpinResult] = useState(null);
  const [showResult, setShowResult] = useState(false);
  const [wheelSize, setWheelSize] = useState(() => getLandingWheelSize());
  const [showIdleCarousel, setShowIdleCarousel] = useState(false);

  const drawWheel = (rotation) => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    const size = canvas.width;
    const cx = size / 2;
    const cy = size / 2;
    const r = cx - 6;
    const n = segments.length;
    const arc = (2 * Math.PI) / n;

    ctx.clearRect(0, 0, size, size);

    // Outer glow ring
    ctx.save();
    ctx.shadowColor = 'rgba(249,115,22,0.6)';
    ctx.shadowBlur = 18;
    ctx.beginPath();
    ctx.arc(cx, cy, r + 2, 0, 2 * Math.PI);
    ctx.strokeStyle = 'rgba(249,115,22,0.4)';
    ctx.lineWidth = 4;
    ctx.stroke();
    ctx.restore();

    segments.forEach((seg, i) => {
      const start = rotation + i * arc;
      const end = start + arc;
      const mid = start + arc / 2;

      ctx.beginPath();
      ctx.moveTo(cx, cy);
      ctx.arc(cx, cy, r, start, end);
      ctx.closePath();
      ctx.fillStyle = seg.color;
      ctx.fill();
      ctx.strokeStyle = 'rgba(255,255,255,0.55)';
      ctx.lineWidth = 2;
      ctx.stroke();

      ctx.save();
      ctx.translate(cx + Math.cos(mid) * r * 0.60, cy + Math.sin(mid) * r * 0.60);
      ctx.rotate(mid + Math.PI / 2);
      ctx.shadowColor = 'rgba(15, 23, 42, 0.3)';
      ctx.shadowBlur = 8;
      ctx.shadowOffsetY = 2;
      ctx.fillStyle = seg.textColor;
      ctx.strokeStyle = 'rgba(15, 23, 42, 0.22)';
      ctx.lineWidth = Math.max(2, size * 0.003);
      ctx.font = `800 ${size * 0.043}px Arial,sans-serif`;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      seg.label.split('\n').forEach((ln, li, arr) => {
        const y = (li - (arr.length - 1) / 2) * size * 0.05;
        ctx.strokeText(ln, 0, y);
        ctx.fillText(ln, 0, y);
      });
      ctx.restore();
    });

    // Hub
    const hub = ctx.createRadialGradient(cx, cy, 0, cx, cy, r * 0.11);
    hub.addColorStop(0, '#fff');
    hub.addColorStop(1, '#f1f5f9');
    ctx.beginPath();
    ctx.arc(cx, cy, r * 0.11, 0, 2 * Math.PI);
    ctx.fillStyle = hub;
    ctx.fill();
    ctx.strokeStyle = '#e2e8f0';
    ctx.lineWidth = 2;
    ctx.stroke();
  };

  useEffect(() => {
    const resetIdleTimer = () => {
      if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
      setShowIdleCarousel(false);
      idleTimerRef.current = setTimeout(() => {
        setShowIdleCarousel(true);
      }, IDLE_CAROUSEL_DELAY);
    };

    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
    events.forEach((eventName) => window.addEventListener(eventName, resetIdleTimer));
    resetIdleTimer();

    return () => {
      if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
      events.forEach((eventName) => window.removeEventListener(eventName, resetIdleTimer));
    };
  }, []);

  useEffect(() => {
    const handleResize = () => setWheelSize(getLandingWheelSize());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    drawWheel(spinRef.current.rotation);
    const ref = spinRef.current;
    return () => cancelAnimationFrame(ref.rafId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wheelSize, segments]);

  const handleSpin = () => {
    if (isSpinning || hasSpun) return;
    setIsSpinning(true);

    const n = segments.length;
    const fullCircle = 2 * Math.PI;
    const arc = (2 * Math.PI) / n;
    const winIdx = Math.floor(Math.random() * n);
    const start = spinRef.current.rotation;
    const normalizedStart = ((start % fullCircle) + fullCircle) % fullCircle;
    const winnerCenterAtTop = -Math.PI / 2 - (winIdx * arc + arc / 2);
    const normalizedTarget = ((winnerCenterAtTop % fullCircle) + fullCircle) % fullCircle;
    const deltaToTarget = normalizedTarget - normalizedStart;
    const positiveDelta = deltaToTarget >= 0 ? deltaToTarget : deltaToTarget + fullCircle;
    const delta = 5 * fullCircle + positiveDelta;
    const dur = 4200;
    let t0 = null;
    const easeOut = (time) => 1 - Math.pow(1 - time, 4);

    const tick = (ts) => {
      if (!t0) t0 = ts;
      const p = Math.min((ts - t0) / dur, 1);
      const angle = start + delta * easeOut(p);
      spinRef.current.rotation = angle;
      drawWheel(angle);
      if (p < 1) {
        spinRef.current.rafId = requestAnimationFrame(tick);
      } else {
        setIsSpinning(false);
        setHasSpun(true);
        const wonSegment = segments[winIdx];
        setSpinResult(wonSegment);

        if (wonSegment.percent) {
          localStorage.setItem('spin_reward_fee_discount_percent', String(wonSegment.percent));
        } else {
          localStorage.removeItem('spin_reward_fee_discount_percent');
        }
        // legacy flag from the old fixed-20%-only wheel, kept clear so it can't override the new reward
        localStorage.removeItem('spin_reward_20_percent_fee');

        setShowResult(true);
      }
    };
    spinRef.current.rafId = requestAnimationFrame(tick);
  };

  const handleApplyNow = () => navigate('/login');

  return (
    <div className="kiosk-container">
      {entryLoaderMessage && <FullPageLoader message={entryLoaderMessage} />}
      {!showIdleCarousel && <LanguageToggle />}
      <div className="kiosk-bottom">
        <div className="lp-inner">
          <div className="lp-cta">
            <h1>{t.headingLine1}<br />{t.headingLine2}</h1>
            <p className="subtitle">{t.subtitle}</p>

            <button
              type="button"
              className="primary-btn landing-apply-btn"
              onClick={handleApplyNow}
            >
              {t.applyNow}
            </button>

            <div className="lp-spin">
              <div className="lp-spin-header">
                <span className="lp-spin-badge">🎁 {t.luckyDraw}</span>
                <p className="lp-spin-title">{t.spinTitle}</p>
                <p className="lp-spin-sub">{t.spinSub}</p>
              </div>

              <div className="lp-spin-arena">
                <div className="lp-spin-pointer">▼</div>
                <div className="lp-spin-spark lp-spin-spark-a" />
                <div className="lp-spin-spark lp-spin-spark-b" />
                <div className="lp-spin-spark lp-spin-spark-c" />
                <div className="lp-spin-ring">
                  <canvas
                    ref={canvasRef}
                    width={wheelSize}
                    height={wheelSize}
                    className="lp-spin-canvas"
                  />
                </div>
              </div>

              <button
                className={`lp-spin-btn${isSpinning ? ' spinning' : ''}${hasSpun ? ' spun' : ''}`}
                onClick={handleSpin}
                disabled={isSpinning || hasSpun}
              >
                <span className="lp-spin-mascot" aria-hidden="true">
                  <video
                    className="lp-spin-mascot-media"
                    src={`${process.env.PUBLIC_URL}/fox.webm`}
                    poster={`${process.env.PUBLIC_URL}/dancing-fox.png`}
                    autoPlay
                    loop
                    muted
                    playsInline
                    preload="metadata"
                    style={{
                      opacity: 1,
                      transition: 'opacity 0.5s ease'
                    }}
                  />
                </span>
                <span className="lp-spin-btn-copy">
                  {isSpinning ? t.spinning : hasSpun ? t.rewardLocked : t.spinNow}
                </span>
              </button>

              {hasSpun && !showResult && spinResult && (
                <div className="lp-spin-teaser-container">
                  <p className="lp-spin-teaser">
                    {t.youWon} <strong>{spinResult.emoji} {spinResult.label.replace('\n', ' ')}</strong>
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {showIdleCarousel && (
        <div className="idle-carousel-overlay" role="presentation">
          <Carousel slides={slides} interval={4000} />
        </div>
      )}

      {showResult && spinResult && (
        <div className="lp-overlay" onClick={() => setShowResult(false)}>
          <div className="lp-result-box" onClick={(e) => e.stopPropagation()}>
            <div className="lp-result-emoji">{spinResult.emoji}</div>
            <h2 className="lp-result-title">{t.modalTitle}</h2>
            <div className="lp-result-prize" style={{ background: spinResult.color }}>
              {spinResult.label.replace('\n', ' ')}
            </div>
            <p className="lp-result-desc">
              {t.modalDescLine1}<br />{t.modalDescLine2}
            </p>
            <button className="lp-result-cta" onClick={() => { setShowResult(false); navigate('/login'); }}>
              {t.modalApply}
            </button>
            <button className="lp-result-close" onClick={() => setShowResult(false)}>
              {t.close}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default LandingPage;
